// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Ej6Z","upload":"Small_upload__VU81U","imageWrap":"Small_imageWrap__1QlV4","removeBtn":"Small_removeBtn__Ye-YE"};